import { ITEM_TYPES } from "./item-types.js";
export * from "./api-token.js";
export * from "./capture-source.js";
export * from "./item-types.js";
export * from "./item-ownership.js";
export * from "./reminders.js";
export * from "./organisation-colour.js";
export * from "./organisation-ownership.js";
export * from "./oauth.js";
// const googleRecaptchaSiteKey = '6LdT_l8UAAAAAOYpCXZTGOxwJk1gU9pk9djyZpBT';
export const ALLOWED_PRIORITIZABLE_TYPES = [ITEM_TYPES.todoText.name];
export const DATE_PICKER_DATEFNS_DATE_FORMAT = 'dd-MMM-yyyy';
export const DATE_PICKER_DATEFNS_SHORT_DATE_FORMAT = 'dd-MMM-yy';
export const DEFAULT_PANE_WIDTH = 400;
export const DEFAULT_PRIORITIZED_PANE_WIDTH = 540;
// Expanded-sidebar default. Shared because the header aligns its search
// button's left edge to this, so the two must not drift apart.
export const DEFAULT_SIDEBAR_WIDTH = 240;
export const DEFAULT_TIMEZONE = 'Europe/London';
export const DEFAULT_TIMEZONE_ID = 'f1e6caeed8eb4cad353c5b769aacf361';
export const DEFAULT_UNPRIORITIZED_PANE_WIDTH = 540;
export const DND_DROP_EDGE_BOTTOM = 'bottom';
export const DND_DROP_EDGE_TOP = 'top';
export const EVENT_TYPES = {
    ADD_ITEM: 'ADD_ITEM',
    UPDATE_ITEM: 'UPDATE_ITEM',
    ADD_ITEM_SHARE: 'ADD_ITEM_SHARE',
    UPDATE_ITEM_SHARE: 'UPDATE_ITEM_SHARE',
    ADD_ORGANISATION: 'ADD_ORGANISATION',
    UPDATE_ORGANISATION: 'UPDATE_ORGANISATION',
    DELETE_ITEM_SHARE: 'DELETE_ITEM_SHARE',
    NUM_REMINDERS: 'NUM_REMINDERS',
};
export const ITEM_PRIORITY_BASE = 16384;
export const MIN_SEARCH_TERM_LENGTH = 2;
export const ORGANISATION_INVITE_LINK_EXPIRY_SECONDS = 1800; // 30 min
export const PRIORITY_AREA_EMPTY = 'empty';
export const PRIORITY_AREA_TODAY = 'today';
export const PRIORITY_AREA_UNDATED = 'undated';
export const REACT_APP_MOUNT = 'react-app';
export const REACT_PORTAL_MOUNT = 'portal-root';
export const SEARCH_PANE_SCOPE_FAVOURITES = 'favourites';
export const SEARCH_PANE_SCOPE_WORKSPACE = 'workspace';
export const SEARCH_PANE_SCOPE_SEARCH = 'search';
export const UNPRIORITIZED_AREA_ALL = 'unprioritizedAll';
export const UNPRIORITIZED_LIST_ORDER_BY = {
    createdDate: 'createdDate',
    itemTitle: 'itemTitle',
    parentTitle: 'parentTitle',
};
export const WEBSOCKET_TIMEOUT = 20000;
export const WORKSPACE_PADDING = 60;
export const WORKSPACE_DEFAULT_SPLIT = 3;
//# sourceMappingURL=index.js.map